import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Button, Space, Table, Tag, message } from 'antd';
import { Link } from 'react-router-dom';
import { PlusCircleOutlined, LinkOutlined, UnorderedListOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatDate, getErrorMessages } from 'app/utils/functions';
import { getTsaTrialPeriodList } from '../service';
import { buildTsaTrialPublicLink } from '../publicLink';

const STATUS_MAP = {
  0: { text: 'Ẩn', color: 'default' },
  1: { text: 'Mở', color: 'success' },
  2: { text: 'Đóng', color: 'error' },
};

class AdminTsaTrialPeriodList extends Component {
  state = {
    loading: false,
    items: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true });
    const response = await getTsaTrialPeriodList();
    if (response.data.code === 200) {
      this.setState({ items: response.data.data.items || [] });
    } else {
      message.error(getErrorMessages(response.data));
    }
    this.setState({ loading: false });
  };

  copyLink = (code) => {
    const link = buildTsaTrialPublicLink(code);
    navigator.clipboard.writeText(link);
    message.success('Đã copy link đăng ký');
  };

  columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    {
      title: 'Đợt đăng ký',
      dataIndex: 'title',
      render: (title, record) => (
        <Space direction="vertical" size={2}>
          <Link
            style={{ color: '#ce1628' }}
            to={`/admin/tsa-trial-periods/edit/${record.id}`}
          >
            {title}
          </Link>
          <span>
            Slug: <code>{record.code}</code>
          </span>
          <span>
            Hạn đăng ký:{' '}
            {record.registration_deadline
              ? moment(record.registration_deadline).format('DD/MM/YYYY HH:mm')
              : '-'}
          </span>
          <span>Đã đăng ký: {record.registration_count ?? 0}</span>
        </Space>
      ),
    },
    {
      title: 'Trạng thái',
      width: 120,
      dataIndex: 'status',
      render: (status, record) => {
        const meta = STATUS_MAP[status] || STATUS_MAP[0];
        return (
          <Space direction="vertical" size={2}>
            <Tag color={meta.color}>{meta.text}</Tag>
            {record.is_active === 1 && <Tag color="blue">Active</Tag>}
          </Space>
        );
      },
    },
    {
      title: 'Thao tác',
      width: 220,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Link to={`/admin/tsa-trial-periods/${record.id}/registrations`}>
            <Button type="link" icon={<UnorderedListOutlined />} className="pl-0">
              Danh sách đăng ký
            </Button>
          </Link>
          <Button
            type="link"
            icon={<LinkOutlined />}
            onClick={() => this.copyLink(record.code)}
            className="pl-0"
          >
            Copy link
          </Button>
        </Space>
      ),
    },
    {
      title: 'Cập nhật',
      width: 120,
      dataIndex: 'updated_at',
      render: (value) => (value ? formatDate(value) : '-'),
    },
  ];

  render() {
    const { loading, items } = this.state;

    return (
      <Container className="page-exam">
        <Row>
          <Col xs={12}>
            <div className="flex space-between align-center mb-4">
              <h3>Quản lý đợt đăng ký thi trải nghiệm TSA</h3>
              <Link to="/admin/tsa-trial-periods/create">
                <Button type="primary" icon={<PlusCircleOutlined />}>
                  Thêm đợt
                </Button>
              </Link>
            </div>
            <Table
              rowKey="id"
              loading={loading}
              columns={this.columns}
              dataSource={items}
              pagination={false}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AdminTsaTrialPeriodList;
